import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,1766.67759 L1551.8744,1398.44355 C1666.16141,1251.62704 1734.9071,1067.61846 1734.9071,867.453549 C1734.9071,389.161349 1345.74575,0 867.453549,0 C389.161349,0 0,389.161349 0,867.453549 C0,1345.74575 389.161349,1734.9071 867.453549,1734.9071 C1067.61846,1734.9071 1251.51861,1666.05297 1398.44355,1551.8744 L1766.67759,1920 L1920,1766.67759 Z M867.453549,1518.04371 C508.653075,1518.04371 216.863387,1226.25402 216.863387,867.453549 C216.863387,508.653075 508.653075,216.863387 867.453549,216.863387 C1226.25402,216.863387 1518.04371,508.653075 1518.04371,867.453549 C1518.04371,1226.25402 1226.25402,1518.04371 867.453549,1518.04371 L867.453549,1518.04371 Z M975.885243,487.942622 L759.021856,487.942622 L759.021856,759.021856 L487.942622,759.021856 L487.942622,975.885243 L759.021856,975.885243 L759.021856,1246.96448 L975.885243,1246.96448 L975.885243,975.885243 L1246.96448,975.885243 L1246.96448,759.021856 L975.885243,759.021856 L975.885243,487.942622 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconZoomInSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconZoomInSolid, _Component);

  var _super = _createSuper(IconZoomInSolid);

  function IconZoomInSolid() {
    _classCallCheck(this, IconZoomInSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconZoomInSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconZoomIn",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconZoomInSolid.displayName = "IconZoomInSolid";
  return IconZoomInSolid;
}(Component);

IconZoomInSolid.glyphName = 'zoom-in';
IconZoomInSolid.variant = 'Solid';
IconZoomInSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconZoomInSolid;
export { IconZoomInSolid };